import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class McqStatusUpdateService extends BaseService {
  constructor() {
    super(constants.MCQ_QUESTION_UPDATE_STATUS, 'ChatGptUtilityUpdateMcqQuestionStatus');
  }

  handleEvent(eventName, event) {
    const { payload, headers } = utils.buildRequestPartsFromPayload(event);
    return this.getClient('aiadmin').post(`/chatutility/quizmcq/updatequestionstatus`, payload, { headers });
  }

  handleResponse(response) {
    const { data } = response;
    if (data.status === 'success') {
      const notification = {
        open: true,
        type: 'success',
        message: 'Question Published successfully'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
      Framework.getStoreRegistry().getStore('chatgptTocUtility').setupdateMcqQuestionResponse(response.data);
    }
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
  }
}
